import React from 'react';

const GoogleAgendaLink = ({ text, startDate, endDate, email }) => {
  text = encodeURIComponent(text);
  const formatDate = (date) => `${date.toISOString().replace(/[-:]/g, '').split('.')[0]}Z`;
  const startStr = formatDate(startDate);
  const endStr = formatDate(endDate);
  return (
    <a
      href={`https://calendar.google.com/calendar/render?action=TEMPLATE&trp=true&text=${text}&dates=${startStr}/${endStr}&add=${email}`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        textDecoration: 'none'
      }}
    >
      <img
        src="https://ssl.gstatic.com/calendar/images/dynamiclogo_2020q4/calendar_16_2x.png"
        alt="Ícone do Google Agenda"
        style={{ width: '24px', height: '24px' }}
      />
    </a>
  );
};

export default GoogleAgendaLink;
